import type { AuthStore } from '@/scopes/auth/domain/types'

export function getRetryAfterMinutes(state: AuthStore) {
  return Math.ceil((state.submitError?.retryAfterSeconds ?? 0) / 60)
}

export function getIsSubmitDisabled(state: AuthStore) {
  return state.submitStatus === 'loading' || state.pageInitializationStatus !== 'success'
}

export function getIsPageInitializing(state: AuthStore) {
  return state.pageInitializationStatus === 'idle' || state.pageInitializationStatus === 'loading'
}
